/* eslint-disable */
// https://dev2.bhsn.it/api/btls/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'btls';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}

/**
 * 표준계약서 조회 V2
 * @returns BtlsResponseStandardFormDetailDtoV2 OK
 * @throws ApiError
 */
export function getStandardFormV2(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormDetailDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/v2',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 수정
 * @returns BtlsResponseStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function updateStandardFormV2(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/{standardFormId}/v2',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 조회
 * @returns BtlsResponseStandardFormDetailDto OK
 * @throws ApiError
 */
export function getStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 수정
 * @returns BtlsResponseStandardFormCreatedDto OK
 * @throws ApiError
 */
export function updateStandardForm(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 삭제
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function deleteStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 버전 변경
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function rollbackVersion(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormTemplateRollbackForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/{standardFormId}/templates/rollback/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 활성화 상태 변경
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function changeActiveStatus(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormActiveStatusForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/{standardFormId}/active-status/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 계약 목록 검색 V1
 * @returns BtlsResponseListLanguageContractTypeDto OK
 * @throws ApiError
 */
export function getWorkspaceContractTypes(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListLanguageContractTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/workspace-contract-types/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 계약 목록 사용 설정 폼 V1
 * @returns any OK
 * @throws ApiError
 */
export function updateWorkspaceContractTypes(
    {
        requestBody,
    }: {
        requestBody: Array<BtlsAvailableContractTypeForm>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/workspace-contract-types/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 사용 계약 카테고리 목록 검색 V1
 * @returns BtlsResponseListLanguageCategoryTypeDto OK
 * @throws ApiError
 */
export function getWorkspaceCategoryTypes(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListLanguageCategoryTypeDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/workspace-category-types/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 사용 계약 카테고리 설정 폼 V1
 * @returns any OK
 * @throws ApiError
 */
export function updateWorkspaceCategoryTypes(
    {
        requestBody,
    }: {
        requestBody: Array<BtlsAvailableCategoryTypeForm>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/workspace-category-types/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 사용 설정 검색 V2
 * @returns BtlsResponseAvailableGlobalStandardFormDtoV2 OK
 * @throws ApiError
 */
export function getWorkspaceGlobalStandardFormInfoV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseAvailableGlobalStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/global-standard-form/available/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 리스트 사용 설정 폼 V2
 * @returns any OK
 * @throws ApiError
 */
export function updateWorkspaceGlobalStandardFormInfoV2(
    {
        requestBody,
    }: {
        requestBody: BtlsAvailableGlobalStandardFormUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/global-standard-form/available/v2',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 사용 설정 검색 V1
 * @returns BtlsResponseAvailableGlobalStandardFormDto OK
 * @throws ApiError
 */
export function getWorkspaceGlobalStandardFormInfoV1(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseAvailableGlobalStandardFormDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/global-standard-form/available/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 리스트 사용 설정 폼 V1
 * @returns any OK
 * @throws ApiError
 */
export function updateWorkspaceGlobalStandardFormInfoV1(
    {
        requestBody,
    }: {
        requestBody: BtlsAvailableGlobalStandardFormUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/global-standard-form/available/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 활성화된 표준계약서 목록 조회
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageActiveStandardForms(
    {
        page,
        size = 30,
        sort,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/active/v1',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 글로벌 표준계약서 사용 설정
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function updateGlobalAvailableStatus(
    {
        requestBody,
    }: {
        requestBody: BtlsAvailableGlobalStandardFormUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/standard-forms/active/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 조회
 * @returns BtlsResponseListStandardFormTemplateDto OK
 * @throws ApiError
 */
export function listStandardFormTemplates(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListStandardFormTemplateDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/templates/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 양식 업로드
 * @returns BtlsResponseStandardFormTemplateCreatedDto OK
 * @throws ApiError
 */
export function uploadStandardFormTemplate(
    {
        standardFormId,
        formData,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        formData?: {
            form: BtlsStandardFormTemplateCreateForm;
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/templates/v1',
                path: {
                    standardFormId: standardFormId,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 다운로드 by JSON
 * @returns BtlsStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadByJson(
    {
        standardFormId,
        fileFormat,
        saveMode,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 다운로드 포맷
         */
        fileFormat: 'DOCX' | 'PDF';
        /**
         * 다운로드 형태
         */
        saveMode: 'CLEANED' | 'ALL';
        requestBody: BtlsDocument;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/templates/download/by-json/v1',
                path: {
                    standardFormId: standardFormId,
                },
                query: {
                    fileFormat: fileFormat,
                    saveMode: saveMode,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 양식 업로드 by maker
 * @returns BtlsResponseStandardFormTemplateCreatedDto OK
 * @throws ApiError
 */
export function uploadStandardFormTemplateByMaker(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormTemplateCreateByMakerForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/templates/by-maker/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 복제
 * @returns BtlsResponseStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function copyStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/copy/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 북마크 등록
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function registerBookmark(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/bookmarks/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 북마크 삭제
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function deleteBookmark(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/standard-forms/{standardFormId}/bookmarks/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 등록
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function createStandardFormAttachment(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormAttachmentCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/{standardFormId}/attachments/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 목록 조회 V2
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageByConditionV2(
    {
        searchKeyword,
        contractTypes,
        activeStatuses,
        languages,
        userIds,
        searchKeywordType,
        sortDirection,
        page,
        size = 30,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 계약서 유형
         */
        contractTypes?: Array<string>;
        /**
         * 계약서 상태
         */
        activeStatuses?: 'ACTIVE' | 'INACTIVE';
        /**
         * 언어
         */
        languages?: Array<string>;
        /**
         * 사용자
         */
        userIds?: Array<number>;
        /**
         * 검색 키워드 타입
         */
        searchKeywordType?: 'ALL' | 'NAME' | 'DESCRIPTION' | 'GUIDELINES' | 'USE_CASES' | 'OUR_POSITION';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/v2',
                query: {
                    searchKeyword: searchKeyword,
                    contractTypes: contractTypes,
                    activeStatuses: activeStatuses,
                    languages: languages,
                    userIds: userIds,
                    searchKeywordType: searchKeywordType,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성
 * @returns BtlsResponseStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function createStandardFormV2(
    {
        formData,
    }: {
        formData?: {
            form: BtlsStandardFormCreateFormV2;
            standardFormFile: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/v2',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 목록 조회
 * @returns BtlsResponsePageStandardFormDto OK
 * @throws ApiError
 */
export function pageByCondition(
    {
        searchKeyword,
        contractTypes,
        activeStatuses,
        languages,
        userIds,
        searchKeywordType,
        sortDirection,
        page,
        size = 30,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 계약서 유형
         */
        contractTypes?: Array<string>;
        /**
         * 계약서 상태
         */
        activeStatuses?: 'ACTIVE' | 'INACTIVE';
        /**
         * 언어
         */
        languages?: 'KOREAN' | 'ENGLISH' | 'ETC';
        /**
         * 사용자
         */
        userIds?: Array<number>;
        /**
         * 검색 키워드 타입
         */
        searchKeywordType?: 'ALL' | 'NAME' | 'DESCRIPTION' | 'GUIDELINES' | 'USE_CASES' | 'OUR_POSITION';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/v1',
                query: {
                    searchKeyword: searchKeyword,
                    contractTypes: contractTypes,
                    activeStatuses: activeStatuses,
                    languages: languages,
                    userIds: userIds,
                    searchKeywordType: searchKeywordType,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성
 * @returns BtlsResponseStandardFormCreatedDto OK
 * @throws ApiError
 */
export function createStandardForm(
    {
        formData,
    }: {
        formData?: {
            form: BtlsStandardFormCreateForm;
            standardFormFile: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/v1',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성 by maker V1
 * @returns BtlsResponseStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function createStandardFormByMaker(
    {
        requestBody,
    }: {
        requestBody: BtlsStandardFormCreateByMakerForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/standard-forms/by-maker/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * Tiptap 문서 다운로드(docx) V1
 * @returns BtlsStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadDocument(
    {
        fileName,
        fileFormat,
        saveMode,
        requestBody,
    }: {
        fileName: string;
        fileFormat: 'DOCX' | 'PDF';
        saveMode: 'CLEANED' | 'ALL';
        requestBody: BtlsDocument;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/documents/download/v1',
                query: {
                    fileName: fileName,
                    fileFormat: fileFormat,
                    saveMode: saveMode,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 문서 변환 (개발용입니다. 실사용 X)
 * @returns BtlsStreamingResponseBody OK
 * @throws ApiError
 */
export function convertDocumentForDev(
    {
        language,
        version,
        formData,
    }: {
        language?: string;
        version?: 'V1' | 'V2';
        formData?: {
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/documents/by-file/dev/v1',
                query: {
                    language: language,
                    version: version,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 버전 별 조회(document)
 * @returns BtlsResponseStandardFormTemplateDetailDto OK
 * @throws ApiError
 */
export function getTemplateByVersion(
    {
        standardFormId,
        version,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 템플릿 버전
         */
        version: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/templates/version/{version}/v1',
                path: {
                    standardFormId: standardFormId,
                    version: version,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 조회(document)
 * @returns BtlsResponseStandardFormTemplateDetailDto OK
 * @throws ApiError
 */
export function getTemplate(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/templates/latest/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 클린버전 다운로드
 * @returns BtlsStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadCleaned(
    {
        standardFormId,
        version,
        format,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 템플릿 버전
         */
        version: number;
        /**
         * 다운로드 포맷
         */
        format: 'DOCX' | 'PDF';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/templates/download/CLEANED/v1',
                path: {
                    standardFormId: standardFormId,
                },
                query: {
                    version: version,
                    format: format,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadStandardFormAttachment(
    {
        standardFormId,
        standardFormAttachmentId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 표준계약서 첨부파일 ID
         */
        standardFormAttachmentId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/{standardFormId}/attachments/{standardFormAttachmentId}/download/v1',
                path: {
                    standardFormId: standardFormId,
                    standardFormAttachmentId: standardFormAttachmentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 목록 조회 V3
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageByConditionV3(
    {
        searchKeyword,
        contractTypes,
        activeStatuses,
        languages,
        userIds,
        searchKeywordType,
        sortDirection,
        page,
        size = 30,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 계약서 유형
         */
        contractTypes?: Array<string>;
        /**
         * 계약서 상태
         */
        activeStatuses?: 'ACTIVE' | 'INACTIVE';
        /**
         * 언어
         */
        languages?: Array<string>;
        /**
         * 사용자
         */
        userIds?: Array<number>;
        /**
         * 검색 키워드 타입
         */
        searchKeywordType?: 'ALL' | 'NAME' | 'DESCRIPTION' | 'GUIDELINES' | 'USE_CASES' | 'OUR_POSITION';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/v3',
                query: {
                    searchKeyword: searchKeyword,
                    contractTypes: contractTypes,
                    activeStatuses: activeStatuses,
                    languages: languages,
                    userIds: userIds,
                    searchKeywordType: searchKeywordType,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 관리자용 미사용 표준계약서 목록 조회 V1
 * @returns BtlsResponseListStandardFormDtoV2 OK
 * @throws ApiError
 */
export function getUnavailableStandardFormsV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/unavailable/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * 관리자용 미사용 표준계약서 목록 조회 V1
 * @returns BtlsResponseListStandardFormDtoV2 OK
 * @throws ApiError
 */
export function getUnavailableStandardFormsByAdminV1(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/unavailable/by-admin/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회 V3
 * @returns BtlsResponseListStandardFormTemplateConfigDtoV2 OK
 * @throws ApiError
 */
export function getTemplateConfigsV3(
    {
        type,
    }: {
        type: 'MAPPING_FIELD' | 'PRESET_FIELD';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/template/configs/v3',
                query: {
                    type: type,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회 V2
 * @returns BtlsResponseListStandardFormTemplateConfigDtoV2 OK
 * @throws ApiError
 */
export function getTemplateConfigsV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/template/configs/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회
 * @returns BtlsResponseListStandardFormTemplateConfigDto OK
 * @throws ApiError
 */
export function getTemplateConfigs(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/template/configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 메타 조회
 * @returns BtlsResponseMapStringListObject OK
 * @throws ApiError
 */
export function getStandardFormMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 북마크 조회 V2
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageBookmarkByConditionV2(
    {
        page,
        size = 30,
        sort,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/bookmarks/v2',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 북마크 조회
 * @returns BtlsResponsePageStandardFormDto OK
 * @throws ApiError
 */
export function pageBookmarkByCondition(
    {
        page,
        size = 30,
        sort,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/bookmarks/v1',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 활성화된 표준계약서 목록 조회 V2
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageActiveStandardFormsV3(
    {
        page,
        size = 30,
        sort,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/active/v3',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 활성화된 표준계약서 목록 조회 V2
 * @returns BtlsResponsePageStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageActiveStandardFormsV2(
    {
        page,
        size = 30,
        sort,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/standard-forms/active/v2',
                query: {
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 계약서 문서 미리보기 (file to document) V1
 * @returns BtlsResponseDocument OK
 * @throws ApiError
 */
export function getDocumentByFile(
    {
        fileKey,
        language,
    }: {
        /**
         * 계약서 파일 key
         */
        fileKey: string;
        /**
         * 언어
         */
        language?: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseDocument> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/documents/by-file/v1',
                query: {
                    language: language,
                    fileKey: fileKey,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 삭제
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function deleteStandardFormAttachment(
    {
        standardFormId,
        standardFormAttachmentId,
    }: {
        standardFormId: number;
        standardFormAttachmentId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/standard-forms/{standardFormId}/attachments/{standardFormAttachmentId}/v1',
                path: {
                    standardFormId: standardFormId,
                    standardFormAttachmentId: standardFormAttachmentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 조회 V2
 * @returns BtlsResponseGlobalStandardFormDetailDtoV2 OK
 * @throws ApiError
 */
export function getGlobalStandardFormV2(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormDetailDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/v2',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 수정 V2
 * @returns BtlsResponseGlobalStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function updateGlobalStandardFormV2(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsGlobalStandardFormUpdateFormV2;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/standard-forms/{standardFormId}/v2',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 조회
 * @returns BtlsResponseGlobalStandardFormDetailDto OK
 * @throws ApiError
 */
export function getGlobalStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 수정
 * @returns BtlsResponseGlobalStandardFormCreatedDto OK
 * @throws ApiError
 */
export function updateGlobalStandardForm(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsGlobalStandardFormUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 삭제
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function deleteGlobalStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/standard-forms/{standardFormId}/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 버전 변경
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function rollbackGlobalVersion(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormTemplateRollbackForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/standard-forms/{standardFormId}/templates/rollback/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 활성화 상태 변경
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function changeGlobalActiveStatus(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormActiveStatusForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/standard-forms/{standardFormId}/active-status/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 노출 글로벌 표준계약서 조회
 * @returns BtlsResponseListGlobalStandardFormDto OK
 * @throws ApiError
 */
export function getWorkspaceGlobalStandardForms(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListGlobalStandardFormDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/workspace/{workspaceId}/v1',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 노출 글로벌 표준계약서 목록 수정
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function updateWorkspaceGlobalStandardForms(
    {
        workspaceId,
        requestBody,
    }: {
        workspaceId: number;
        requestBody: BtlsWorkspaceGlobalStandardFormUpdateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'PUT',
                url: '/super-admin/standard-forms/workspace/{workspaceId}/v1',
                path: {
                    workspaceId: workspaceId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 조회
 * @returns BtlsResponseListStandardFormTemplateDto OK
 * @throws ApiError
 */
export function listGlobalStandardFormTemplates(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListStandardFormTemplateDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/templates/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 양식 업로드
 * @returns BtlsResponseStandardFormTemplateCreatedDto OK
 * @throws ApiError
 */
export function uploadGlobalStandardFormTemplate(
    {
        standardFormId,
        formData,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        formData?: {
            form: BtlsStandardFormTemplateCreateForm;
            file: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/{standardFormId}/templates/v1',
                path: {
                    standardFormId: standardFormId,
                },
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 양식 업로드 by maker
 * @returns BtlsResponseStandardFormTemplateCreatedDto OK
 * @throws ApiError
 */
export function uploadGlobalStandardFormTemplateByMaker(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormTemplateCreateByMakerForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/{standardFormId}/templates/by-maker/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 복제
 * @returns BtlsResponseGlobalStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function copyGlobalStandardForm(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/{standardFormId}/copy/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 등록
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function createGlobalStandardFormAttachment(
    {
        standardFormId,
        requestBody,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        requestBody: BtlsStandardFormAttachmentCreateForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/{standardFormId}/attachments/v1',
                path: {
                    standardFormId: standardFormId,
                },
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 목록 조회 V2
 * @returns BtlsResponsePageGlobalStandardFormDtoV2 OK
 * @throws ApiError
 */
export function pageGlobalByConditionV2(
    {
        searchKeyword,
        contractTypes,
        activeStatuses,
        languages,
        userIds,
        searchKeywordType,
        sortDirection,
        page,
        size = 30,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 계약서 유형
         */
        contractTypes?: Array<string>;
        /**
         * 계약서 상태
         */
        activeStatuses?: 'ACTIVE' | 'INACTIVE';
        /**
         * 언어
         */
        languages?: Array<string>;
        /**
         * 사용자
         */
        userIds?: Array<number>;
        /**
         * 검색 키워드 타입
         */
        searchKeywordType?: 'ALL' | 'NAME' | 'DESCRIPTION' | 'GUIDELINES' | 'USE_CASES' | 'OUR_POSITION';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageGlobalStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/v2',
                query: {
                    searchKeyword: searchKeyword,
                    contractTypes: contractTypes,
                    activeStatuses: activeStatuses,
                    languages: languages,
                    userIds: userIds,
                    searchKeywordType: searchKeywordType,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성 V2
 * @returns BtlsResponseGlobalStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function createGlobalStandardFormV2(
    {
        formData,
    }: {
        formData?: {
            form: BtlsGlobalStandardFormCreateFormV2;
            standardFormFile: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/v2',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 목록 조회
 * @returns BtlsResponsePageGlobalStandardFormDto OK
 * @throws ApiError
 */
export function pageGlobalByCondition(
    {
        searchKeyword,
        contractTypes,
        activeStatuses,
        languages,
        userIds,
        searchKeywordType,
        sortDirection,
        page,
        size = 30,
        sort,
    }: {
        /**
         * 검색 키워드
         */
        searchKeyword?: string;
        /**
         * 계약서 유형
         */
        contractTypes?: Array<string>;
        /**
         * 계약서 상태
         */
        activeStatuses?: 'ACTIVE' | 'INACTIVE';
        /**
         * 언어
         */
        languages?: 'KOREAN' | 'ENGLISH' | 'ETC';
        /**
         * 사용자
         */
        userIds?: Array<number>;
        /**
         * 검색 키워드 타입
         */
        searchKeywordType?: 'ALL' | 'NAME' | 'DESCRIPTION' | 'GUIDELINES' | 'USE_CASES' | 'OUR_POSITION';
        /**
         * 정렬 방향
         */
        sortDirection?: 'ASC' | 'DESC';
        /**
         * Zero-based page index (0..N)
         */
        page?: number;
        /**
         * The size of the page to be returned
         */
        size?: number;
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponsePageGlobalStandardFormDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/v1',
                query: {
                    searchKeyword: searchKeyword,
                    contractTypes: contractTypes,
                    activeStatuses: activeStatuses,
                    languages: languages,
                    userIds: userIds,
                    searchKeywordType: searchKeywordType,
                    sortDirection: sortDirection,
                    page: page,
                    size: size,
                    sort: sort,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성
 * @returns BtlsResponseGlobalStandardFormCreatedDto OK
 * @throws ApiError
 */
export function createGlobalStandardForm(
    {
        formData,
    }: {
        formData?: {
            form: BtlsGlobalStandardFormCreateForm;
            standardFormFile: Blob;
        };
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/v1',
                formData: formData,
                mediaType: 'multipart/form-data',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 생성 by maker V1
 * @returns BtlsResponseGlobalStandardFormCreatedDtoV2 OK
 * @throws ApiError
 */
export function createGlobalStandardFormByMaker(
    {
        requestBody,
    }: {
        requestBody: BtlsGlobalStandardFormCreateByMakerForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseGlobalStandardFormCreatedDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/super-admin/standard-forms/by-maker/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 버전 별 조회(document)
 * @returns BtlsResponseStandardFormTemplateDetailDto OK
 * @throws ApiError
 */
export function getGlobalTemplateByVersion(
    {
        standardFormId,
        version,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 템플릿 버전
         */
        version: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/templates/version/{version}/v1',
                path: {
                    standardFormId: standardFormId,
                    version: version,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 조회(document)
 * @returns BtlsResponseStandardFormTemplateDetailDto OK
 * @throws ApiError
 */
export function getGlobalTemplate(
    {
        standardFormId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseStandardFormTemplateDetailDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/templates/latest/v1',
                path: {
                    standardFormId: standardFormId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 클린버전 다운로드
 * @returns BtlsStreamingResponseBody OK
 * @throws ApiError
 */
export function downloadGlobalCleaned(
    {
        standardFormId,
        version,
        format,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 템플릿 버전
         */
        version: number;
        /**
         * 다운로드 포맷
         */
        format: 'DOCX' | 'PDF';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsStreamingResponseBody> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/templates/download/CLEANED/v1',
                path: {
                    standardFormId: standardFormId,
                },
                query: {
                    version: version,
                    format: format,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 다운로드
 * @returns any OK
 * @throws ApiError
 */
export function downloadGlobalStandardFormAttachment(
    {
        standardFormId,
        standardFormAttachmentId,
    }: {
        /**
         * 표준계약서 ID
         */
        standardFormId: number;
        /**
         * 표준계약서 첨부파일 ID
         */
        standardFormAttachmentId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<any> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/{standardFormId}/attachments/{standardFormAttachmentId}/download/v1',
                path: {
                    standardFormId: standardFormId,
                    standardFormAttachmentId: standardFormAttachmentId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 노출 글로벌 표준계약서 조회 V2
 * @returns BtlsResponseListGlobalStandardFormDtoV2 OK
 * @throws ApiError
 */
export function getWorkspaceGlobalStandardFormsV2(
    {
        workspaceId,
    }: {
        workspaceId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListGlobalStandardFormDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/workspace/{workspaceId}/v2',
                path: {
                    workspaceId: workspaceId,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회 V3
 * @returns BtlsResponseListStandardFormTemplateConfigDtoV2 OK
 * @throws ApiError
 */
export function getGlobalTemplateConfigsV3(
    {
        type,
    }: {
        type: 'MAPPING_FIELD' | 'PRESET_FIELD';
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/template/configs/v3',
                query: {
                    type: type,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회 V2
 * @returns BtlsResponseListStandardFormTemplateConfigDtoV2 OK
 * @throws ApiError
 */
export function getGlobalTemplateConfigsV2(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDtoV2> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/template/configs/v2',
            }),
            requestConfig,
        ),
    );
}
/**
 * @deprecated
 * 표준계약서 템플릿 구성에 필요한 정보 목록 조회
 * @returns BtlsResponseListStandardFormTemplateConfigDto OK
 * @throws ApiError
 */
export function getGlobalTemplateConfigs(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseListStandardFormTemplateConfigDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/template/configs/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 메타 조회
 * @returns BtlsResponseMapStringListObject OK
 * @throws ApiError
 */
export function getGlobalStandardFormMeta(_?: any, requestConfig?: RequestConfig): AxiosPromise<BtlsResponseMapStringListObject> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/standard-forms/meta/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 도큐먼트 미리보기 (file to document)
 * @returns BtlsResponseDocument OK
 * @throws ApiError
 */
export function getSuperAdminDocumentByFile(
    {
        fileKey,
        language,
    }: {
        /**
         * 계약서 파일 key
         */
        fileKey: string;
        /**
         * 언어
         */
        language: string;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponseDocument> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/super-admin/documents/by-file/v1',
                query: {
                    fileKey: fileKey,
                    language: language,
                },
            }),
            requestConfig,
        ),
    );
}
/**
 * 표준계약서 첨부파일 삭제
 * @returns BtlsResponse OK
 * @throws ApiError
 */
export function deleteGlobalStandardFormAttachment(
    {
        standardFormId,
        standardFormAttachmentId,
    }: {
        standardFormId: number;
        standardFormAttachmentId: number;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<BtlsResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/super-admin/standard-forms/{standardFormId}/attachments/{standardFormAttachmentId}/v1',
                path: {
                    standardFormId: standardFormId,
                    standardFormAttachmentId: standardFormAttachmentId,
                },
            }),
            requestConfig,
        ),
    );
}
